import * as React from 'react';
import classNames from 'classnames';
import * as moment from 'moment';

import YearSelect from '../YearSelect';
import MonthSelect from '../MonthSelect';
import CalendarNavButton from './CalendarNavButton';

import CalendarDayPicker from './CalendarDayPicker';

import IMPComponent from '../interfaces/IMPComponent';
import { ISelectOptionType } from '../Select';

import './styles.scss';

export interface ICalendarProps extends IMPComponent {
  month: number;
  year: number;
  selectedDate?: string | Date;
  expectedWordsCount: number;
  onNextClick?: (event: React.MouseEvent) => void;
  onPrevClick?: (event: React.MouseEvent) => void;
  onMonthChange?: (data: ISelectOptionType) => void;
  onYearChange?: (data: ISelectOptionType) => void;
  onDayClick?: (data: Date) => void;
  firstDayOfWeek?: number;
  wordsCountToDays: { [key: string]: number };
}

interface HeaderProps {
  readonly month: number;
  readonly year: number;
  readonly onNextClick?: (event: React.MouseEvent) => void;
  readonly onPrevClick?: (event: React.MouseEvent) => void;
  readonly onMonthChange?: (data: ISelectOptionType) => void;
  readonly onYearChange?: (data: ISelectOptionType) => void;
}

const CalendarHeader = React.memo((props: HeaderProps) => {
  return (
    <div className="Calendar-header">
      <CalendarNavButton iconName="arrow-left-circle-outlined" onClick={props.onPrevClick} />
      <div className="Calendar-selects">
        <div className="Calendar-selectsItem">
          <MonthSelect selectedMonth={props.month} onChange={props.onMonthChange} />
        </div>
        <div className="Calendar-selectsItem Calendar-selectsItem--year">
          <YearSelect selectedYear={props.year} onChange={props.onYearChange} />
        </div>
      </div>
      <CalendarNavButton iconName="arrow-right-circle-outlined" onClick={props.onNextClick} />
    </div>
  );
});

function Calendar(props: ICalendarProps) {
  const {
    className,
    style,
    month,
    year,
    onNextClick,
    onPrevClick,
    onMonthChange,
    onYearChange,
    selectedDate,
    expectedWordsCount,
    onDayClick,
    firstDayOfWeek,
    wordsCountToDays,
  } = props;

  const cn = classNames('Calendar', className);
  return (
    <div className={cn} style={style}>
      <CalendarHeader
        month={month}
        year={year}
        onNextClick={onNextClick}
        onPrevClick={onPrevClick}
        onMonthChange={onMonthChange}
        onYearChange={onYearChange}
      />
      <div className="Calendar-dates">
        <CalendarDayPicker
          wordsCountToDays={wordsCountToDays}
          expectedWordsCount={expectedWordsCount}
          selectedDays={moment(selectedDate)
            .startOf('day')
            .toDate()}
          onDayClick={onDayClick}
          month={moment()
            .month(month)
            .year(year)
            .startOf('day')
            .toDate()}
          firstDayOfWeek={firstDayOfWeek}
        />
      </div>
    </div>
  );
}

Calendar.defaultProps = {
  firstDayOfWeek: 1,
};

export default Calendar;



// WEBPACK FOOTER //
// ./src/components/Calendar/index.tsx